<template>
  <div class="usc-listImg gutter-lg mb body">
    <div class="usc-listImg__col">
      <slot name="title"></slot>
      <slot name="body"></slot>
      <ul>
        <slot name="item"></slot>
      </ul>
    </div>
    <div class="usc-listImg__col usc-listImg__col--pd">
      <slot name="img"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListImage',
  props: [],
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '~styles/vars';

  .usc-listImg {
    display: flex;
    flex-flow: column-reverse;
    @media (min-width: $screen-sm-min) {
      flex-flow: row;
    }
    ul {
      margin-top: 22px;
    }
    li {
      list-style-type: none;
      margin-bottom: 10px;
    }
    &__col {
      width: 100%;
      min-height: 100%;
      @media (min-width: $screen-sm-min) {
        width: 50%;
      }
      &--pd {
        padding-bottom: 30px;
        padding-left: 0;
        @media (min-width: $screen-sm-min) {
          padding-left: 30px;
          padding-bottom: 0;
        }
      }
      img {
        display: block;
        width: 100%;
        box-shadow: 0px 8px 18px rgba(0, 0, 0, 0.08);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ListImage.vue